<template>
    <page-container class="grid grid-cols-12 gap-8">
        <settings-sidebar></settings-sidebar>
        <div ref="content" class="col-span-12 md:col-span-8 lg:col-span-9">
            <profile-settings v-if="hash === 'profile' || !hash" v-model:user="currentUser"></profile-settings>

            <teams-settings
                v-if="hash === 'teams' && usesTeams"
                :user="props.user"
                :teams="props.teams"
            ></teams-settings>

            <invites-settings v-if="hash === 'invites' && !props.user.isUsingSingleSignOn" />

            <security-settings v-if="hash === 'security' && !props.user.isUsingSingleSignOn" :user="props.user" />

            <api-settings
                v-if="onCorporate() && hash === 'api' && usesApi && !props.user.isUsingSingleSignOn"
            ></api-settings>
        </div>
    </page-container>
</template>

<script setup>
import PageContainer from '~/components/general/PageContainer.vue';
import ProfileSettings from '../profile/ProfileSettings.vue';
import InvitesSettings from '../invites/InvitesSettings.vue';
import TeamsSettings from '../teams/TeamsSettings.vue';
import SecuritySettings from '../security/SecuritySettings.vue';
import ApiSettings from '../api/ApiSettings.vue';
import { ref } from 'vue';
import SettingsSidebar from './SettingsSidebar.vue';
import { useBrowserLocation } from '@vueuse/core';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import { useSettingsHash } from '~/composables/useSettingsHash';

const props = defineProps({
    user: Object,
    teams: Object,
});

const { onCorporate } = useCurrentGroup();

const currentUser = ref({ ...props.user });

const usesTeams = Spark.usesTeams;
const usesApi = Spark.usesApi;

const location = useBrowserLocation();
const { hash, content } = useSettingsHash();

if (!hash.value) {
    location.value.hash = '#/profile';
}
</script>
